import { ChangeDetectionStrategy, Component, OnInit, inject } from "@angular/core";
import { Observable, combineLatest, firstValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { MatbeskedDto } from "~app/features/virkeskop/dto/matbesked/matbesked-dto";
import { KontraktMediatorService } from "~app/features/virkeskop/services/kontrakt-mediator.service";
import { MatbeskedMediatorService } from "~app/features/virkeskop/services/matbesked-mediator.service";

type MatbeskedVM = {
    awaitingMatbesked: boolean;
    isRotpost?: boolean;
    matbesked: MatbeskedDto;
    requestingMatbesked: boolean;
};

@Component({
    selector: "rask-kontrakt-matbesked",
    imports: [RaskCommonModule],
    templateUrl: "./kontrakt-matbesked.component.html",
    styleUrl: "./kontrakt-matbesked.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KontraktMatbeskedComponent implements OnInit {
    protected matbeskedVM$: Observable<MatbeskedVM>;

    private readonly kontraktMediatorService = inject(KontraktMediatorService);
    private readonly matbeskedMediatorService = inject(MatbeskedMediatorService);
    private readonly raskModalService = inject(RaskModalService);

    hamtaMatbeskedClick() {
        this.matbeskedMediatorService.fetchMatbesked();
    }

    ngOnInit(): void {
        this.matbeskedVM$ = combineLatest([
            this.matbeskedMediatorService.matbesked$,
            this.kontraktMediatorService.kontrakt$,
            this.matbeskedMediatorService.awaitingMatbesked$,
            this.matbeskedMediatorService.sendingMatbesked$
        ]).pipe(
            map(([
                matbesked,
                kontrakt,
                loading,
                sending
            ]) => ({
                matbesked,
                isRotpost: kontrakt.isRotpost,
                awaitingMatbesked: loading,
                requestingMatbesked: sending
            }))
        );
    }

    async skapaMatbeskedClick() {
        const answer = await firstValueFrom(
            this.raskModalService.confirm(new ModalSettings("Varning",
                "Mätbesked skapas och skickas alltid av Biometria till leverantör ca 2 veckor efter sista inmätningen."
                + " Om du fortsätter kommer mätbesked att skapas/beställas direkt och skickas av Biometria till leverantören.")));
        if (answer === ConfirmDialogResponse.cancel) {
            return;
        }
        this.matbeskedMediatorService.createMatbesked();
    }
}
